import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92739f00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-login__item user-login__success" }
const _hoisted_2 = { class: "user-login__success-foot" }
const _hoisted_3 = { class: "user-login__success-yellow" }

import { ref } from 'vue';
import { BaseSvg } from '@/components/base/base-svg';
import { useInterval } from '@vueuse/core';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'login-success',
  setup(__props) {

const router = useRouter();
const counter = ref(2);
const { pause } = useInterval(1000, {
  controls: true,
  immediate: true,
  callback: () => {
    counter.value--;
    if (counter.value <= 0) {
      pause();
      goHome();
    }
  }
});
const goHome = (): void => {
  router.replace({ path: '/' });
};

const onJump = (): void => {
  goHome();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseSvg), {
      iconClass: `chenggong`,
      className: "user-login__success-svg"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createTextVNode(" 密码设置成功, "),
        _createElementVNode("span", _hoisted_3, _toDisplayString(counter.value), 1),
        _createTextVNode(" 秒后将直接登录 ")
      ]),
      _createElementVNode("p", null, [
        _createTextVNode(" 若无反应点击进入 "),
        _createElementVNode("span", {
          class: "user-login__success-yellow user-login__success-jump",
          onClick: onJump
        }, " SaaS业务平台 ")
      ])
    ])
  ]))
}
}

})